import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

import { HttpMethods } from 'consts/httpMethods';
import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { upsertCompanyOffice } from 'modules/settings/api';

export const useMutationCompanyOfficeUpsert = () => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const { successToast, errorToast } = useCustomToast();

  const {
    mutateAsync: companyOfficeUpsert,
    isLoading: companyOfficeMutateLoading,
    isError: companyOfficeMutateError,
  } = useMutation(upsertCompanyOffice, {
    onSuccess: response => {
      const responseMethod = response?.config?.method;
      const name = response?.data?.name;
      let successMessage = '';

      if (responseMethod === HttpMethods.PUT) {
        successMessage = t('Office successfully edited', { who: name });
      } else if (responseMethod === HttpMethods.POST) {
        successMessage = t('Office successfully created', { who: name });
      }
      successToast(successMessage);
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_COMPANY_DATA);
      queryClient.refetchQueries(QUERY_KEYS.RENTALS_OFFICES);
    },
    onError: () => errorToast(),
    onSettled: () => queryClient.refetchQueries(QUERY_KEYS.SETTINGS_PROFILE_COMPANY_DATA),
  });

  return {
    companyOfficeUpsert,
    companyOfficeMutateLoading,
    companyOfficeMutateError,
  };
};
